package com.eladfinish.bible.contest.data

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class BookSederItem(
    @SerialName("book") val name: String,
    @SerialName("sections") val sections: List<SederInfo>,
)

@Serializable
data class SederInfo(
    @SerialName("seder") val seder: String,
    @SerialName("name") val name: String,
    @SerialName("start") val start: VerseRef,
    @SerialName("end") val end: VerseRef,
)

@Serializable
data class VerseRef(
    @SerialName("book") val book: String,
    @SerialName("chapter") val chapter: String,
    @SerialName("verse") val verse: String,
)

@Serializable
data class RefRange(
    val start: VerseRef,
    val end: VerseRef,
)
